import React from "react";
import { Modal, Button, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SuccessPopupBlue = ({
  open,
  primaryURL,
  secondaryURL,
  message,
  handleCloseSuccessPopup,
  primaryText,
  secondaryText,
  title,
  child,
}) => {
  const navigate = useNavigate();

  const handlePrimaryAction = () => {
    handleCloseSuccessPopup();
    if (primaryURL) {
      navigate(primaryURL);
    }
  };

  const handleSecondaryAction = () => {
    handleCloseSuccessPopup();
    if (secondaryURL) {
      navigate(secondaryURL);
    }
  };
  return (
    <Modal
      show={open}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-success-dialog"
    >
      <Modal.Body className="text-center d-flex flex-column row-gap-4">
        <h2 className="fw-bolder m-0" style={{ fontSize: "28px" }}>
          {title}
        </h2>
        <p style={{ color: "#171717" }} className="text-break m-0">
          {message}
        </p>
        {child}
        <Stack direction="horizontal" className="gap-3 flex-wrap-reverse">
          {secondaryText && (
            <Button
              variant="dark fw-bold flex-grow-1"
              type="submit"
              onClick={handleSecondaryAction}
              style={{ paddingBlock: "10px", fontSize: "18px" }}
            >
              {secondaryText}
            </Button>
          )}
          <Button
            variant="primary"
            size="lg"
            className="fw-bold flex-grow-1"
            onClick={handlePrimaryAction}
            style={{ fontSize: "18px" }}
          >
            {primaryText}
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessPopupBlue;
